import { defineMessages } from 'react-intl';

const messages = defineMessages({
  noImage: {
    id: 'ImageCarousel.NoImage',
    defaultMessage: 'No Image Found',
  },
  mainTag: {
    id: 'ImageCarousel.MainTag',
    defaultMessage: 'MAIN',
  },
  srcLinkText: {
    id: 'ImageCarousel.SrcLinkText',
    defaultMessage: 'Open in New Window',
  },
  originLabel: {
    id: 'ImageCarousel.OriginLabel',
    defaultMessage: 'Source',
  },
  sourceLabel: {
    id: 'ImageCarousel.SourceLabel',
    defaultMessage: 'Link',
  },
  filePathLabel: {
    id: 'ImageCarousel.FilePathLabel',
    defaultMessage: 'File Path',
  },
  myUnfiAlt: {
    id: 'ImageCarousel.myUnfiAlt',
    defaultMessage: 'Available on myUNFI',
  },
});

export default messages;
